import React from 'react'
import Experience from './Experience'
import Skills from './Skills'

function Resume() {
  return (
    <div className='  pt-[130px] pb-[130px]  md:pl-[70px] md:pr-[70px] pl-2 pr-2'>
        <p className="text-center">
        <span className="p-2 about__me__title ">Resume</span>
      </p>
      <h1 className="text-center know__me__title mt-6 " style={{fontSize: 'clamp(2rem,4vw,6rem)'}}>
      A summary of My Resume
      </h1>
      <Experience/>
      <Skills/>
    </div>
  )
}

export default Resume